import styled from 'styled-components'
import { Typography } from '../../../../Common'

export const FlexRow = styled.div.attrs({
  className: 'd-flex',
})``

export const BoldText = styled(Typography)`
  font-weight: 500;
`
